import { createFileRoute } from "@tanstack/react-router";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import AdminPressureWashers from "@/pages/admin/AdminPressureWashers";

export const Route = createFileRoute("/admin/pressure-washers/")({
  component: () => (
    <ProtectedRoute>
      <AdminPressureWashers />
    </ProtectedRoute>
  ),
});
